/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Possible device modes.
 * <br><br>
 * - 0: hamp
 * - 1: hssp
 * - 2: hdsp
 * - 3: maintenance
 * - 4: hsp
 * - 5: ota
 * - 6: button
 * - 7: idle
 * - 8: vibrate
 * - 9: hrpp
 *
 */
export enum DeviceModeValue {
    /**
     * HAMP
     */
    HAMP = 0,
    /**
     * HSSP
     */
    HSSP = 1,
    /**
     * HDSP
     */
    HDSP = 2,
    /**
     * Maintenance
     */
    MAINTENANCE = 3,
    /**
     * HSP
     */
    HSP = 4,
    /**
     * OTA
     */
    OTA = 5,
    /**
     * Button
     */
    BUTTON = 6,
    /**
     * Idle
     */
    IDLE = 7,
    /**
     * Vibrate
     */
    VIBRATE = 8,
    /**
     * HRPP
     */
    HRPP = 9,
}
